import { ADMIN_USERS_ENDPOINTS, AdminUsersService } from "@/service/api/admin-users";
import { useQuery } from "@tanstack/react-query";

interface UseUserDetailsParams {
  id: string;
  enabled?: boolean;
}

const useUserDetails = ({ id, enabled }: UseUserDetailsParams) => {
  const query = useQuery({
    queryKey: [ADMIN_USERS_ENDPOINTS.GET_USER(id)],
    queryFn: () => AdminUsersService.getUser(id),
    enabled,
  });

  return query;
};

export default useUserDetails;
